module.exports = __webpack_public_path__ + "media/sonic.803e8468.webm";